export default __webpack_public_path__ + "static/media/e_wdt_c_6.a7cefe92.mp3";